export default "__VITE_ASSET__BxpocVBd__"